import CommissionContext from 'contexts/CommissionContext';
import { useContext } from 'react';

const useCommission = () => {
  const { companyId, permissions, isCommissionClosed, invalidate } = useContext(CommissionContext);
  return { companyId, permissions, isCommissionClosed, invalidate };
};

export default useCommission;
